import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./auth/AuthProvider.js";
import { Button, Card } from "./components/index.js";
import { AppShell } from "./shell/AppShell.js";
import { RequireRole } from "./shell/RequireRole.js";
import { LoginPage } from "./pages/LoginPage.js";
import { GerenciarEnviosPage } from "./pages/GerenciarEnviosPage.js";
import { CriarEnviosPage } from "./pages/CriarEnviosPage.js";
import { InventarioPage } from "./pages/InventarioPage.js";
import { FornecedoresPage } from "./pages/FornecedoresPage.js";
import { PrepCenterPage } from "./pages/PrepCenterPage.js";
import { UsuariosPage } from "./pages/UsuariosPage.js";
import { RelatorioPage } from "./pages/RelatorioPage.js";
import { ConfiguracoesPage } from "./pages/ConfiguracoesPage.js";
import type { ReactNode } from "react";

export function App(): ReactNode {
  const { status, errorMessage, me, logout } = useAuth();

  if (status === "loading") {
    return <CenteredMessage title="Carregando…" />;
  }

  if (status === "anonymous") {
    return <LoginPage />;
  }

  if (status === "not_registered") {
    return (
      <BlockedScreen
        title="Acesso não autorizado"
        message={
          errorMessage ??
          "Seu usuário não possui cadastro interno ativo no FiCC. Fale com um administrador."
        }
        onLogout={() => void logout()}
      />
    );
  }

  if (status === "error") {
    return (
      <BlockedScreen
        title="Não foi possível carregar o perfil"
        message={errorMessage ?? "Tente novamente em instantes."}
        onLogout={() => void logout()}
      />
    );
  }

  // status === "authorized"
  if (me === null) {
    return <CenteredMessage title="Carregando…" />;
  }

  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<GerenciarEnviosPage />} />
        <Route path="criar" element={<CriarEnviosPage />} />
        <Route path="inventario" element={<InventarioPage />} />
        <Route
          path="fornecedores"
          element={
            <RequireRole role="ADMIN">
              <FornecedoresPage />
            </RequireRole>
          }
        />
        <Route path="prep-center" element={<PrepCenterPage />} />
        <Route
          path="usuarios"
          element={
            <RequireRole role="ADMIN">
              <UsuariosPage />
            </RequireRole>
          }
        />
        <Route path="relatorio" element={<RelatorioPage />} />
        <Route
          path="configuracoes"
          element={
            <RequireRole role="ADMIN">
              <ConfiguracoesPage />
            </RequireRole>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

function CenteredScreen({ children }: { children: ReactNode }): ReactNode {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--bg)",
        padding: "1.5rem"
      }}
    >
      {children}
    </div>
  );
}

function CenteredMessage({ title }: { title: string }): ReactNode {
  return (
    <CenteredScreen>
      <Card>{title}</Card>
    </CenteredScreen>
  );
}

function BlockedScreen({
  title,
  message,
  onLogout
}: {
  title: string;
  message: string;
  onLogout: () => void;
}): ReactNode {
  return (
    <CenteredScreen>
      <Card style={{ width: 360 }}>
        <h1 style={{ fontSize: 18, fontWeight: 700, marginBottom: "0.5rem" }}>
          {title}
        </h1>
        <p style={{ fontSize: 13, color: "var(--text-muted)", marginBottom: "1rem" }}>
          {message}
        </p>
        <Button variant="secondary" onClick={onLogout}>
          Sair
        </Button>
      </Card>
    </CenteredScreen>
  );
}
